import useWebStorageApi from '@/hooks/useWebStorageApi'
import window from '@/helpers/WindowHelper'

const useSessionStorage = (key, initialValue) =>
  useWebStorageApi(window.sessionStorage, key, initialValue)

export default useSessionStorage
